import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    socketData: undefined
}

const socketDataSlice = createSlice({
    name: "Socket Data",
    initialState: initialState,
    reducers: {
        setSocketData: (state, actions) => {
            state.socketData = actions.payload
        }
    }
})


export const { setSocketData } = socketDataSlice.actions

export default socketDataSlice.reducer